import HttpRequest from "@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest";
import SnackbarUtils from "@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils";
import { TIMEOUT } from 'dns';
import store from '../../../store/store';

class IntervaloController {
  public static async insertIntervalo(
    nrVinculo: string,
    date: string,
    time: string,
    before: boolean,
    ocorrencia: any,
  ) {
    const nrOrg = store.getters.user.nrorg;

    const route = 'insertIntervalo';

    const params = {
      requestType: 'Row',
      row: {
        NRORG: nrOrg,
        NRVINCULOM: nrVinculo,
        DATE: date,
        HORARIO: time,
        BEFORE: before,
        ocorrencia,
      },
    };

    try {
      const response = await HttpRequest.post(route, params, false);

      if (response.data.messages !== undefined) {
        const message = response.data.messages[0].message;
        SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

        return false;
      }

      let success = false;

      try {
        success = response.data.dataset.data.success || false;
      } finally {
        if (!success) {
          throw new Error('Invalid response!');
        }
      }

      const message = 'Intervalo criado com sucesso!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_SUCCESS);

      return true;
    } catch (err) {
      const errorMessage = 'Não foi possível inserir o intervalo!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async deleteIntervalo(
    nrVinculo: string,
    date: string,
    hrInicio: string,
    hrFim: string,
    before: boolean,
  ) {
    const route = 'deleteIntervalo';

    const nrOrg = store.getters.user.nrorg;

    const params = {
      requestType: 'Row',
      row: {
        NRORG: nrOrg,
        NRVINCULOM: nrVinculo,
        DATE: date,
        DTHRINICIO: hrInicio,
        DTHRFIM: hrFim,
        before,
      },
    };

    try {
      const response = await HttpRequest.post(route, params, false);

      if (response.data.messages !== undefined) {
        const message = response.data.messages[0].message;
        SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

        return false;
      }

      let success = false;

      try {
        success = response.data.dataset.data.success || false;
      } finally {
        if (!success) {
          throw new Error('Invalid response!');
        }
      }

      const message = 'Intervalo excluído com sucesso!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_SUCCESS);

      return success;
    } catch (err) {
      const errorMessage = 'Não foi possível excluir o intervalo!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }
}

export default IntervaloController;